module.exports = __webpack_public_path__ + "img/Currency.7775aee5.svg";